import { memo } from "react";
import { convertUrlTObject, sharekakaoApi, shareKakaoTalk } from "../../../../utils/helpers";
import { ReactComponent as IconDownload } from '../../../../assets/images/nav/icon_download.svg';
import { ReactComponent as IconKakao } from '../../../../assets/images/nav/icon_kakao.svg';
import { ReactComponent as IconInfo } from '../../../../assets/images/nav/icon_information.svg';
import { ReactComponent as IconDelete } from '../../../../assets/images/nav/icon_delete.svg';
type props = {
  albumDetail: Array,
  callDeleteAlbum: Function,
  callShowInfo: Function
}
const NavigateImg = ({albumDetail, callDeleteAlbum, callShowInfo}:props) => {

  const handleDowloadAlbum = () => {
    // let data = convertUrlTObject(albumDetail.photo_url?.original || '');
    console.log('handleDowloadAlbum', albumDetail.photo_url?.original || '');
    window.nativeDownloadAlbum(albumDetail.photo_url?.original || '');
  }

  const handleShareKakaoAlbum = () => {
    let pathName = `album/detail/${albumDetail.id}`;
    let linkRedirect =  `${process.env.REACT_APP_URL}/album/detail/${albumDetail.id}`;

    //share ALBUM_PHOTO
    let data = {
      obj_id: albumDetail?.id || '',
      obj_type: 'ALBUM_PHOTO',
      channel: 'KAKAO'
    }
    sharekakaoApi(data);

    shareKakaoTalk('Sphokidz', '캐릭터 천국, 스포키즈 사진을 공유합니다', albumDetail.photo_url?.original || '', albumDetail.photo_url?.original || '', pathName, linkRedirect);
  }

  const handleShowInfoAlbum = () => {
    callShowInfo()
  }

  const handleDeleteAlbum = () => {
    callDeleteAlbum(albumDetail);
  }

  return (
    <>
      <nav className="bottom-nav album-photo-detail-page__bottom-nav-custom">
        <ul>
          <li>
            <a className="active" onClick={() => {handleDowloadAlbum()}}>
              <span className="on"><IconDownload /></span>
              <span className="off"><IconDownload /></span>
              {/* <img className="on" src="/images/nav/icon_download.svg" />
              <img className="off" src="/images/nav/icon_download.svg" /> */}
            </a>
          </li>
          <li>
            <a onClick={() => {handleShareKakaoAlbum()}}>
              {/* <img className="on" src="/images/nav/icon_kakao.svg" />
              <img className="off" src="/images/nav/icon_kakao.svg" /> */}
              <span className="on"><IconKakao /></span>
              <span className="off"><IconKakao /></span>
            </a>
          </li>
          <li>
            <a onClick={() => {handleShowInfoAlbum()}}>
              {/* <img className="on" src="/images/nav/icon_information.svg" />
              <img className="off" src="/images/nav/icon_information.svg" /> */}
              <span className="on"><IconInfo /></span>
              <span className="off"><IconInfo /></span>
            </a>
          </li>
          <li>
            <a onClick={() => {handleDeleteAlbum()}}>
              {/* <img className="on" src="/images/nav/icon_delete.svg" />
              <img className="off" src="/images/nav/icon_delete.svg" /> */}
              <span className="on"><IconDelete /></span>
              <span className="off"><IconDelete /></span>
            </a>
          </li>
        </ul>
      </nav>
    </>
  )
}

export default memo(NavigateImg);
